import React from "react";

export const focusableElementsSelector = `
    a[href],
    area[href],
    input:not([disabled]),
    select:not([disabled]),
    textarea:not([disabled]),
    button:not([disabled]),
    [tabindex="0"]
`;

const FocusTrap = (
    {
        as,
        children,
        onKeyDown,
        ...otherProps
    }: { as: any; children?: React.ReactNode; onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void },
    ref: any,
) => {
    const Element = as;
    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        const container = ref.current as HTMLElement | null;
        if (!container) {
            if (onKeyDown) onKeyDown(event);
            return;
        }

        const focusableElements = Array.from(container.querySelectorAll<HTMLElement>(focusableElementsSelector));

        if (event.key === "Tab") {
            if (focusableElements.length === 0) {
                event.preventDefault();
                container.focus();
            } else if (event.shiftKey) {
                if (document.activeElement === focusableElements[0]) {
                    event.preventDefault();
                    focusableElements[focusableElements.length - 1].focus();
                }
            } else if (document.activeElement === focusableElements[focusableElements.length - 1]) {
                event.preventDefault();
                focusableElements[0].focus();
            }
        }

        if (onKeyDown) onKeyDown(event);
    };

    return (
        <Element ref={ref} {...otherProps} onKeyDown={handleKeyDown}>
            {children}
        </Element>
    );
};

const FocusTrapWithForwardRef = React.forwardRef(FocusTrap);

export default FocusTrapWithForwardRef;
